function FullscreenLoader({
  text = 'Cargando…',
  percent = null,
  fullscreen = true
}) {
  const formattedPercent =
    percent !== null ? Number(percent).toFixed(2) : null;

  return (
    <>
      <div style={fullscreen ? overlayStyle : inlineStyle}>
        <div style={spinnerStyle} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <p style={textStyle}>
            {text}
            {formattedPercent !== null && (
              <strong style={{ marginLeft: 6 }}>
                {formattedPercent}%
              </strong>
            )}
          </p>

          {formattedPercent !== null && (
            <div style={progressContainer}>
              <div
                style={{
                  ...progressBar,
                  width: `${formattedPercent}%`
                }}
              />
            </div>
          )}
        </div>
      </div>

      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(255,255,255,0.9)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999
};

const inlineStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '12px 16px',
  borderRadius: 12,
  backgroundColor: '#f9fafb',
  border: '1px solid #e5e7eb',
  marginBottom: '1.5rem'
};

const spinnerStyle = {
  width: 32,
  height: 32,
  border: '4px solid #e5e7eb',
  borderTop: '4px solid #2563eb',
  borderRadius: '50%',
  animation: 'spin 0.9s linear infinite'
};

const textStyle = {
  fontSize: 14,
  color: '#374151'
};

const progressContainer = {
  width: 220,
  height: 6,
  backgroundColor: '#e5e7eb',
  borderRadius: 999,
  overflow: 'hidden'
};

const progressBar = {
  height: '100%',
  backgroundColor: '#2563eb',
  transition: 'width 0.4s ease'
};

export default FullscreenLoader;
